<div class="login-container">
  <div class="login-card">
    <div class="login-header">
      <h2>Dobrodošli nazad</h2>
      <p>Molimo vas da se prijavite na svoj račun</p>
    </div>

    <!-- Error Message -->
    <div *ngIf="errorMessage" class="error-message">
      {{ errorMessage }}
    </div>

    <form class="login-form" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="username">Korisničko ime</label>
        <input 
          type="text" 
          id="username" 
          [(ngModel)]="username"
          name="username"
          placeholder="Unesite svoje korisničko ime"
          (input)="onInputChange()"
          required
          [disabled]="isLoading">
      </div>

      <div class="form-group">
        <label for="password">Lozinka</label>
        <input 
          type="password" 
          id="password" 
          [(ngModel)]="password"
          name="password"
          placeholder="Unesite svoju lozinku"
          (input)="onInputChange()"
          required
          [disabled]="isLoading">
      </div>

      <button 
        type="submit" 
        class="login-btn"
        [disabled]="isLoading">
        
        <span *ngIf="!isLoading">Prijavite se</span>
        <span *ngIf="isLoading">Prijavljivanje...</span>
      </button>
    </form>
  </div>
</div>